import React from 'react';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { AnswerLink } from '../../components/Step/AnswerLink';
import { getIndustryLabel } from '../../utils/industries';
import { STEP_INDUSTRY } from '../constants';
import type { SelectedValues } from '../config';

export interface IndustryStepAnswerProps {
    link: string;
    data: SelectedValues;
    onClick: () => void;
}

export function IndustryStepAnswer({ data, link, onClick }: IndustryStepAnswerProps) {
    const value = data[STEP_INDUSTRY];

    if (!value) {
        return null;
    }

    return (
        <FormattedMessage
            message={__('My business is in the {answer} industry.')}
            values={{
                answer: (
                    <AnswerLink href={link} onClick={onClick}>
                        {getIndustryLabel(value)}
                    </AnswerLink>
                ),
            }}
        />
    );
}
